import { createSlice } from '@reduxjs/toolkit';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/purchaseInsurance/basicInfo',
  initialState: {
    beneficiary: '',
    phoneNumber: null,
    phoneCountryCode: null,
    gender: null,
    isValid: false,
    isLoading: false,
    error: null
  },
  reducers: {
    setPlanholderInfo: (
      state,
      { payload: { beneficiary, phoneNumber, phoneCountryCode, gender } }
    ) => {
      state.beneficiary = beneficiary;
      state.phoneNumber = phoneNumber;
      state.phoneCountryCode = phoneCountryCode;
      state.gender = gender;
    },
    setValidity: (state, { payload }) => {
      state.isValid = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const setPlanholderInfo = (payload) => (dispatch) => {
  dispatch(actions.setPlanholderInfo(payload));
};

export const setValidity = (isValid) => (dispatch) => {
  dispatch(actions.setValidity(isValid));
};
